import http from "@/utils/axios";
import { notify } from "@kyvg/vue3-notification";
import router from "../../router";

export default {
  namespaced: true,
  state: {
    checkAll: false,
    billingData: {
      company_name: "",
      sort_code: "",
      bank_name: "",
      nip: "",
      free_from_vat: false,
      vat_registered: false,
      vat_unsure: false,
      street: "",
      house_number: "",
      flat_number: "",
      city: "",
      account_number: "",
      agree1: false,
      agree2: false,
      postal_code: "",
      country: "",
    },
    errors: [],
    authMode: true,
    additionalFormData: {
      doctor_id: null,
    },
  },
  getters: {
    getBillingData: (state) => state.billingData,
    getErrors: (state) => state.errors,
    getCheckAll: (state) => state.checkAll,
    getAuthMode: (state) => state.authMode,
  },
  mutations: {
    setBillingData(state, billingData) {
      Object.assign(state.billingData, billingData);
    },
    setBillingDataValue(state, billingData) {
      Object.assign(state.billingData, billingData);
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    setCheckAll(state, checkAll) {
      state.checkAll = checkAll;
      state.billingData.agree1 = checkAll;
      state.billingData.agree2 = checkAll;
    },
    clearBillingData(state) {
      Object.keys(state.billingData).forEach(
        (key) => (state.billingData[key] = "")
      );
      state.billingData.free_from_vat = false;
      state.billingData.vat_registered = false;
      state.billingData.vat_unsure = false;
    },
    clearErrors(state) {
      state.errors = [];
    },
    setAuthMode(state, value) {
      state.authMode = value;
    },
    setAdditionalFormData(state, doctorId) {
      state.additionalFormData.doctor_id = doctorId;
    },
  },
  actions: {
    async submitBillingForm({ commit, state, rootGetters }, redirect) {
      const hasBillingData = rootGetters["user/getCurrentUserBillingData"]
        ? true
        : false;

      const bilingData = {
        ...state.billingData,
        account_number: state.billingData.account_number.replace("GB", ""),
        ...state.additionalFormData,
        in_register_process:
          router.currentRoute.value.name == "AuthBillingDataMedicalEntity",
      };

      let continueAction = true;
      await http
        .post(
          `/doctor/billing-data/${hasBillingData ? `update` : `store`}`,
          bilingData
        )
        .then(({ data }) => {
          commit("user/setUserBillingData", data.billing_data, {
            root: true,
          });
          commit("clearErrors");
          notify({
            type: "success",
            text: hasBillingData
              ? "messages.edit.success"
              : "messages.save.success",
            duration: 5000,
          });
          if (hasBillingData)
            commit("modals/closeModal", "changeBillingData", { root: true });
          if (redirect) router.push({ name: "Dashboard" });
        })
        .catch(({ response }) => {
          continueAction = false;
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
          }
        });
      return continueAction;
    },
  },
};
